import service from '../../http/axios';

// 获取类型列表 获取标签1列表 传不同的code
export const getCategory = service({
  url: '/yinghe-api/getDicByCode',
});

// 获取标签2列表
export const getTag2 = service({
  url: '/yinghe-api/imageDataScience/listImageTagsByAccountId',
});

// 获取部位列表 部位id 默认108
export const getPosition = service({
  url: '/yinghe-api/getDic',
});

// 获取病症列表
export const getDisease = service({
  url: '/yinghe-api/imageDataScience/diseaseList',
});

// 创建/修改定义
export const createDefinition = service({
  method: 'POST',
  url: '/yinghe-api/imageDataScience/createImageData',
});
